// extracted by mini-css-extract-plugin
export default {"container":"Home_container__qRlyu","container_center":"Home_container_center__5dcAR"};